import { useState, useEffect } from "react";
import Input from "../components/Input";
import { T } from "../constants/theme";
import Btn from "../components/Btn";
import Badge from "../components/Badge";
import StepBar from "../components/StepBar"
import { API_BASE_URL } from "../config";


export default function PaymentStep({ data, onNext }) {
  const [stage, setStage] = useState("redirecting"); // redirecting -> gateway -> processing
  const studentIdShort = (data) => data.mobile;


  useEffect(() => {
    const t1 = setTimeout(
      () => setStage("gateway"),
      1000
    );

    return () => clearTimeout(t1);
  }, []);

  const handlePay = async () => {
    try {
      setStage("processing");

      const registrationId =
        sessionStorage.getItem("registrationId");

      const orderResponse = await fetch(
        `${API_BASE_URL}/api/Registration/${registrationId}/create-order`,
        {
          method: "POST",
        }
      );

      if (!orderResponse.ok) {
        throw new Error("Unable to create order");
      }

      const orderData =
        await orderResponse.json();

      const options = {
        key: orderData.key,

        amount: orderData.amount,

        currency: "INR",

        name: "Shabbas Academy",

        description:
          "State Level Examination Registration",

        order_id: orderData.orderId,

        prefill: {
          name: data.name,

          email: data.email,

          contact: data.mobile,
        },

        theme: {
          color: "#1E3A8A",
        },

        handler: async function (response) {
          try {
            const verifyResponse =
              await fetch(
                `${API_BASE_URL}/api/Registration/verify-payment`,
                {
                  method: "POST",

                  headers: {
                    "Content-Type":
                      "application/json",
                  },

                  body: JSON.stringify({
                    razorpayOrderId:
                      response.razorpay_order_id,

                    razorpayPaymentId:
                      response.razorpay_payment_id,

                    razorpaySignature:
                      response.razorpay_signature,
                  }),
                }
              );

            if (!verifyResponse.ok) {
              throw new Error(
                "Payment verification failed"
              );
            }

            onNext();
          } catch (err) {
            alert(err.message);
          }
        },

        modal: {
          ondismiss: function () {
            setStage("gateway");
          },
        },
      };

      const razorpay =
        new window.Razorpay(options);

      razorpay.open();
    } catch (err) {
      alert(err.message);
      setStage("gateway");
    }
  };

  if (stage === "redirecting") {
    return (
      <div style={{ textAlign: "center", padding: "60px 0" }}>
        <StepBar step={3} />

        <div
          style={{
            width: 44,

            height: 44,

            border: `4px solid ${T.gray200}`,

            borderTopColor: T.saffron,

            borderRadius: "50%",

            margin: "0 auto 18px",

            animation: "spin 0.8s linear infinite",
          }}
        />

        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

        <div style={{ fontWeight: 700, color: T.indigo, fontSize: 15 }}>
          Redirecting to Razorpay…
        </div>

        <div style={{ fontSize: 13, color: T.gray600, marginTop: 4 }}>
          Please do not close this window.
        </div>
      </div>
    );
  }

  return (
    <div>
      <StepBar step={3} />

      <div style={{ marginBottom: 22 }}>
        <Badge>Step 3 of 5</Badge>

        <h2
          style={{
            fontSize: 20,

            fontWeight: 800,

            color: T.indigo,

            margin: "8px 0 4px",
          }}
        >
          Payment
        </h2>

        <p style={{ fontSize: 13, color: T.gray600 }}>
          Secure payment powered by Razorpay.
        </p>
      </div>

      {/* Razorpay-style gateway card */}

      <div
        style={{
          border: `1px solid ${T.gray200}`,

          borderRadius: 14,

          overflow: "hidden",

          marginBottom: 20,
        }}
      >
        <div
          style={{
            background: "#072654",

            color: T.white,

            padding: "14px 20px",

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 18, fontWeight: 900 }}>Razorpay</span>
          </div>

          <Badge color="#3395FF">Secure</Badge>
        </div>

        <div style={{ padding: "22px 20px" }}>
          <div
            style={{
              fontSize: 12,

              color: T.gray600,

              letterSpacing: "0.06em",

              textTransform: "uppercase",

              marginBottom: 6,
            }}
          >
            Examination Fee
          </div>

          <div
            style={{
              fontSize: 40,

              fontWeight: 900,

              color: T.indigo,

              marginBottom: 4,
            }}
          >
            ₹289
          </div>

          <div style={{ fontSize: 13, color: T.gray600, marginBottom: 18 }}>
            Payable by <strong>{data.name}</strong> ({studentIdShort(data)})
          </div>

          <div
            style={{
              fontSize: 12,

              fontWeight: 700,

              color: T.gray600,

              marginBottom: 10,

              letterSpacing: "0.04em",
            }}
          >
            SELECT PAYMENT METHOD
          </div>

          {["UPI", "Credit / Debit Card", "Net Banking", "Wallet"].map(
            (m, i) => (
              <div
                key={m}
                style={{
                  padding: "12px 14px",

                  border: `1.5px solid ${i === 0 ? T.saffron : T.gray200}`,

                  borderRadius: 8,

                  marginBottom: 8,

                  fontSize: 13,

                  fontWeight: 600,

                  color: i === 0 ? T.indigo : T.gray600,

                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "center",

                  background: i === 0 ? T.saffronLight : T.white,

                  cursor: "pointer",
                }}
              >
                {m}

                {i === 0 && (
                  <span
                    style={{
                      width: 16,

                      height: 16,

                      borderRadius: "50%",

                      background: T.saffron,

                      display: "inline-flex",

                      alignItems: "center",

                      justifyContent: "center",

                      color: T.white,

                      fontSize: 10,
                    }}
                  >
                    ✓
                  </span>
                )}
              </div>
            ),
          )}
        </div>
      </div>

      <Btn onClick={handlePay} disabled={stage === "processing"} full>
        {stage === "processing" ? "Processing Payment…" : "Pay ₹289"}
      </Btn>

      <p
        style={{
          textAlign: "center",

          fontSize: 12,

          color: T.gray400,

          marginTop: 12,
        }}
      >
        🔒 256-bit encrypted · Powered by Razorpay
      </p>
    </div>
  );
};